<template>
  <hs-modal
    v-model="open"
    title="Update Settings"
    :description="selectedStore ? `${selectedStore.name} (ID: ${selectedStore.id})` : ''"
    size="lg"
    @close="$emit('close-modal')"
  >
    <div class="us-shell">
      <hs-tabs :tabs="tabs" v-model="selectedTab" />
      <RequestToChangeEbmSettings
        v-if="selectedTab === 'ebmSettings'"
        :settings="settings"
        :loading="loadingToChangeEbmSettings"
        @update-settings="handleSettingsUpdate"
        @close-modal="$emit('close-modal')"
      />
      <RequestToChangeName
        v-else-if="selectedTab === 'nameChange'"
        :loading="loadingToChangeName"
        :requires-approval="Boolean(settings?.ebm_activated)"
        @update-name="handleNameUpdate"
        @close-modal="$emit('close-modal')"
      />
    </div>
  </hs-modal>
</template>

<script>
import RequestToChangeEbmSettings from "./RequestToChangeEbmSettings.vue";
import RequestToChangeName from "./RequestToChangeName.vue";
import { HsModal, HsTabs } from "@/components/ui";

export default {
  name: "UpdateSettings",
  components: { RequestToChangeEbmSettings, RequestToChangeName, HsModal, HsTabs },
  props: {
    settings: { type: Object, required: true },
    loadingToChangeName: { type: Boolean, default: false },
    loadingToChangeEbmSettings: { type: Boolean, default: false },
  },
  emits: ["close-modal", "update-store-details", "update-ebm-settings"],
  data() {
    return {
      open: true,
      selectedTab: "ebmSettings",
      tabs: [
        { id: "ebmSettings", label: "RRA EBM Settings", icon: "settings" },
        { id: "nameChange", label: "Store Details", icon: "edit-3" },
      ],
    };
  },
  computed: {
    selectedStore() {
      const stores = this.$safeJSONParse(localStorage.getItem("stores")) || [];
      const selectedStore = this.$store.getters.getSelectedStore;
      const storeId = typeof selectedStore === "object" ? selectedStore?.id : selectedStore;
      return stores.find((store) => String(store.id) === String(storeId)) ||
        (typeof selectedStore === "object" ? selectedStore : null);
    },
  },
  methods: {
    handleNameUpdate(values) {
      this.$emit("update-store-details", values);
    },
    handleSettingsUpdate(values) {
      this.$emit("update-ebm-settings", values);
    },
  },
};
</script>

<style scoped>
.us-shell {
  display: grid;
  gap: 1rem;
}
</style>
